import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/refresh.svg'


const _hoisted_1 = { class: "flex z-20" }
const _hoisted_2 = { class: "font-semibold self-center mr-10 text-20px whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_3 = { class: "overflow-auto mb-3" }
const _hoisted_4 = { class: "flex flex-col pt-4 pb-1" }
const _hoisted_5 = { class: "flex flex-row justify-end" }
const _hoisted_6 = { class: "text-14px text-gray-lp-800" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_0
}, null, -1)
const _hoisted_8 = {
  class: "flex flex-col w-full p-4 my-4 gap-1 border border-1 border-gray-lp-1400 bg-lp-white",
  style: {"border-radius":"8px"}
}
const _hoisted_9 = { class: "flex flex-row gap-2 w-full" }
const _hoisted_10 = { class: "w-1/2" }
const _hoisted_11 = { class: "w-3/12" }
const _hoisted_12 = { class: "w-3/12" }
const _hoisted_13 = { class: "flex flex-row mb-4" }
const _hoisted_14 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpdateNotification = _resolveComponent("UpdateNotification")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Header = _resolveComponent("Header")!
  const _component_HeaderBeforeSTIDest = _resolveComponent("HeaderBeforeSTIDest")!
  const _component_HeaderSttNowDel = _resolveComponent("HeaderSttNowDel")!
  const _component_HeaderSttOverdueDel = _resolveComponent("HeaderSttOverdueDel")!
  const _component_HeaderSttBar = _resolveComponent("HeaderSttBar")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Print = _resolveComponent("Print")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["pt-8 bg-white flex flex-col  text-12px xxl:text-14px overflow-hidden h-screen relative w-full", _ctx.isSidebarAndBreadcrumbV2 ? 'pt-4' : 'pt-8']
    }, [
      _createVNode(_component_UpdateNotification, {
        successSttPieces: 30,
        errorSttPieces: 10,
        modelValue: _ctx.updateNotificationModel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateNotificationModel = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_Header, { class: "items-center" }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.getTitle), 1)
          ]),
          (_ctx.ableToCreate)
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 0,
                onClick: _ctx.goToUpdate,
                title: _ctx.$t('stiDest.updateStiDest'),
                textColor: "white"
              }, null, 8, ["onClick", "title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("stiDest.dataUpdatedEvery10Min")), 1),
            _hoisted_7,
            _createVNode("div", {
              class: "text-14px font-montserrat font-normal text-red-500 ml-1 cursor-pointer underline",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onRefreshStiDestSummary && _ctx.onRefreshStiDestSummary(...args)))
            }, _toDisplayString(_ctx.$t("stiDest.refresh")), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_HeaderBeforeSTIDest, {
                  totalCargoTruck: _ctx.stiDestSummary.totalCargoTruck,
                  totalCargoPlane: _ctx.stiDestSummary.totalCargoPlane,
                  totalCargoShip: _ctx.stiDestSummary.totalCargoShip,
                  totalSttNeedStiDest: _ctx.stiDestSummary.totalSttNeedStidest,
                  isLoading: _ctx.isStiDestSummaryLoading
                }, null, 8, ["totalCargoTruck", "totalCargoPlane", "totalCargoShip", "totalSttNeedStiDest", "isLoading"])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_HeaderSttNowDel, {
                  totalDelNow: _ctx.stiDestSummary.totalDelNow,
                  totalDelIntracity: _ctx.stiDestSummary.totalDelNowIntracity,
                  totalDelIntercity: _ctx.stiDestSummary.totalDelNowIntercity,
                  isLoading: _ctx.isStiDestSummaryLoading
                }, null, 8, ["totalDelNow", "totalDelIntracity", "totalDelIntercity", "isLoading"])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_HeaderSttOverdueDel, {
                  totalDelOverdue: _ctx.stiDestSummary.totalDelOverdue,
                  totalDelIntracity: _ctx.stiDestSummary.totalDelOverdueIntracity,
                  totalDelIntercity: _ctx.stiDestSummary.totalDelOverdueIntercity,
                  isLoading: _ctx.isStiDestSummaryLoading
                }, null, 8, ["totalDelOverdue", "totalDelIntracity", "totalDelIntercity", "isLoading"])
              ])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_HeaderSttBar, {
                totalPod: _ctx.priorityDelSummary.totalPod,
                totalRts: _ctx.priorityDelSummary.totalRts,
                totalHal: _ctx.priorityDelSummary.totalHal,
                isLoading: _ctx.isPriorSummaryLoading
              }, null, 8, ["totalPod", "totalRts", "totalHal", "isLoading"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Search, {
            class: "w-64 self-center",
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            value: _ctx.searchValue,
            placeholder: _ctx.$t('stiDest.searchPlaceholder'),
            minChar: 1,
            timeout: 1000
          }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
          _createVNode(_component_time_range_picker, {
            default: "7 hari terakhir",
            startDate: _ctx.startDate,
            endDate: _ctx.endDate,
            onSelect: _ctx.setDateRange
          }, null, 8, ["startDate", "endDate", "onSelect"])
        ]),
        (
          _ctx.stiDestList.length === 0 && !_ctx.searchValue && !_ctx.startDate && !_ctx.endDate
        )
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 0,
              data: _ctx.$t('stiDest.emptyData')
            }, null, 8, ["data"]))
          : (_openBlock(), _createBlock(_component_TableV2, {
              key: 1,
              columns: _ctx.columns,
              data: _ctx.stiDestList,
              loading: _ctx.isLoading,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event)),
              onRequest: _ctx.fetchStiDestList,
              errorCause: _ctx.errorCause,
              customButtonAction: _ctx.customButton,
              onTryAgain: _ctx.fetchStiDestList,
              isDetailAble: _ctx.ableToDetail,
              onClick: _ctx.goToDetail,
              "data-testid": "incoming-sti-dest-list-table"
            }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause", "customButtonAction", "onTryAgain", "isDetailAble", "onClick"]))
      ])
    ], 2),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
}